/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnRix.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnRix extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="CnRix-view">
        <Helmet>
          <title>创办人 - 赖钧庭 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="CnRix-first">
          <Link to="/CnTeam">
            <div className="CnRix-back">
              <div className="CnRix-backBtn"></div>
              <div className="CnRix-backText">返回</div>
            </div>
          </Link>

          <div className="CnRixContainer">
            <div className="CnRix-rixPic" />

            <div className="CnRix-name">
              <strong>赖钧庭 Rix Lai </strong>
              <br />
              创办人
            </div>
          </div>
        </div>

        <div className="CnRix-second">
          <div className="CnRix-secondText">
            赖钧庭 Rix Lai 是 CheckPlus 的创办人。
            <p />
            Rix了解在正确的项目中使用正确技术的重要性。
            <p />
            在成立 CheckPlus 之前， 他大部分时间都在学习如何从年轻时开始编码。
            凭借他在技术领域的专业知识和经验，他早期与 CheckPlus
            的产品开发团队合作。
            <p />
            Rix 将很快获得加州大学圣地亚哥分校的电脑科学学士学位。
          </div>
        </div>

        <div className="CnRix-footer">
          <div className="CnRix-footerNav">
            <Link to="/CnTeam">
              <div className="CnRix-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnRix-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnRix-footerNavItem">联络我们</div>
            </Link>
            <Link to="/CnPrivacyPolicy">
              <div className="CnRix-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="CnRix-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="CnRix-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnRix;
